module.exports = __webpack_public_path__ + "assets/img/v3.222bace5.png";